'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, LayoutContainer, Picture } from '@petsmart-ui/sparky';
import cn from 'classnames';
import Link from 'next/link';
import { ContentfulClick } from '@libs/analytics';
import { getImageProps } from '../../../utils/propsImagesItems';
import { Text } from '../../Text';
import type { BrandSpotlightProps } from './types';
import './BrandSpotlight.scss';
export function BrandSpotlight(t0) {
  const $ = _c(50);
  const {
    leftBlock,
    leftBlockTextColor,
    rightBlock
  } = t0;
  if (rightBlock.length !== 2) {
    return null;
  }
  const [brandCard] = leftBlock;
  const [assetLg, assetSm] = rightBlock;
  const Component = brandCard.cta ? Link : "div";
  let t1;
  if ($[0] !== assetSm.image) {
    t1 = getImageProps(assetSm.image);
    $[0] = assetSm.image;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== assetSm.internalTitle || $[3] !== assetSm.link || $[4] !== t1) {
    t2 = {
      image: t1,
      internalTitle: assetSm.internalTitle,
      link: assetSm.link
    };
    $[2] = assetSm.internalTitle;
    $[3] = assetSm.link;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== assetLg.image) {
    t3 = getImageProps(assetLg.image);
    $[6] = assetLg.image;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== assetLg.internalTitle || $[9] !== assetLg.link || $[10] !== t3) {
    t4 = {
      image: t3,
      internalTitle: assetLg.internalTitle,
      link: assetLg.link
    };
    $[8] = assetLg.internalTitle;
    $[9] = assetLg.link;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t4) {
    t5 = {
      sm: t2,
      lg: t4
    };
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const assets = t5;
  let t6;
  if ($[15] !== assets) {
    t6 = Object.entries(assets);
    $[15] = assets;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== brandCard.header || $[18] !== t6) {
    t7 = t6.map(t8 => {
      const [size, t9] = t8;
      const {
        image,
        link,
        internalTitle
      } = t9;
      return <ContentfulClick component={Link} key={size} href={link?.webUrl || ""} className={`brand-spotlight__${size}`} eventData={{
        linkText: link.internalTitle,
        linkUrl: link?.webUrl ?? "",
        promoTitle: brandCard.header,
        promoVariant: "storytelling card up - Brand Spotlight - image",
        promoDesc: internalTitle,
        promoType: `brand-spotlight__${size}`
      }}><Picture {...image} /></ContentfulClick>;
    });
    $[17] = brandCard.header;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== brandCard.backgroundFill) {
    t8 = {
      background: brandCard.backgroundFill
    };
    $[20] = brandCard.backgroundFill;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const t9 = brandCard.cta?.link.webUrl ?? "";
  const t10 = brandCard.cta?.text;
  let t11;
  if ($[22] !== brandCard.bodyText || $[23] !== brandCard.header || $[24] !== t10) {
    t11 = cn(brandCard.header, brandCard.bodyText, t10);
    $[22] = brandCard.bodyText;
    $[23] = brandCard.header;
    $[24] = t10;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const t12 = brandCard.cta?.link.webUrl ?? "";
  let t13;
  if ($[26] !== brandCard.header || $[27] !== brandCard.internalTitle || $[28] !== t11 || $[29] !== t12) {
    t13 = {
      linkText: t11,
      linkUrl: t12,
      promoTitle: brandCard.header,
      promoVariant: "storytelling card up - Brand Spotlight - Card",
      promoDesc: brandCard.internalTitle,
      promoType: "brand-spotlight__card"
    };
    $[26] = brandCard.header;
    $[27] = brandCard.internalTitle;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== brandCard.header || $[32] !== leftBlockTextColor) {
    t14 = <Text color={leftBlockTextColor} as="h2">{brandCard.header}</Text>;
    $[31] = brandCard.header;
    $[32] = leftBlockTextColor;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== brandCard.bodyText || $[35] !== leftBlockTextColor) {
    t15 = <Text color={leftBlockTextColor}>{brandCard.bodyText}</Text>;
    $[34] = brandCard.bodyText;
    $[35] = leftBlockTextColor;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== brandCard.cta) {
    t16 = brandCard.cta && <Button size="sm" text={brandCard.cta.text} variant={brandCard.cta.buttonStyle === "Primary" ? "primary" : "toolbar"} />;
    $[37] = brandCard.cta;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== Component || $[40] !== t13 || $[41] !== t14 || $[42] !== t15 || $[43] !== t16 || $[44] !== t8 || $[45] !== t9) {
    t17 = <ContentfulClick component={Component} className="brand-spotlight__card" style={t8} href={t9} eventData={t13} prefetch={false}>{t14}{t15}{t16}</ContentfulClick>;
    $[39] = Component;
    $[40] = t13;
    $[41] = t14;
    $[42] = t15;
    $[43] = t16;
    $[44] = t8;
    $[45] = t9;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  let t18;
  if ($[47] !== t17 || $[48] !== t7) {
    t18 = <LayoutContainer className="brand-spotlight">{t7}{t17}</LayoutContainer>;
    $[47] = t17;
    $[48] = t7;
    $[49] = t18;
  } else {
    t18 = $[49];
  }
  return t18;
}